import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

const rules = {
    email: ['email'],
    phone: 'valid_phone'
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};